import React from 'react';
import { Balance } from './components/Balance';
import { IncomeExpenses } from './components/IncomeExpenses';
import { TransactionList } from './components/TransactionList';
import { AddTransaction } from './components/AddTransaction';
import '../home/static/style.css';
import { GlobalProvider } from './context/GlobalState';
import money from './img/money.png'

// import './App.css';

function App2() {
  return (
    <GlobalProvider>
      <div className="expenserBg">
<img src={money} alt="expenserLogo" style={{width:"100px", display:'flex', justifyContent:'center', margin:'0 auto'}}/>
      <div className="container2">
        <Balance />
        <IncomeExpenses />
        <TransactionList />
        <AddTransaction />
      </div>
      </div>
    </GlobalProvider>
  );
}

export default App2;